
module Meevo {

  export interface IMeevoSideMenu extends ng.material.ISidenavService {

  }

  export class MeevoSideMenu implements angular.IDirective {
    restrict = "E";

    templateUrl = 'app/components/menu/menu.html';

    constructor() {

    }


    static factory(): angular.IDirectiveFactory {
      let directive = () => {
        return new MeevoSideMenu();
      };

      return directive;
    }
  }

  angular.module("meevo")
    .directive("meevoSideMenu", MeevoSideMenu.factory());
}